/* @flow */
import * as React from 'react';

const StarFullLarge = ({ color = '#505FB4', style, ...rest }: { color: string }) => (
  <svg viewBox="0 0 40 38" style={{ width: 48, ...style }} {...rest}>
    <polygon
      stroke="none"
      strokeWidth={1}
      fill={color}
      fillRule="evenodd"
      points="20 0 26.18 12.342 40 14.334 30 23.935 32.36 37.5 20 31.092 7.64 37.5 10 23.935 0 14.334 13.82 12.342"
    />
  </svg>
);

export default StarFullLarge;



// WEBPACK FOOTER //
// ./src/assets/images/icons/star-full-large.js